<template>
  <div class="new-event-swiper">
    <div class="relative flex items-center justify-between mb-48">
      <h3 class="text-white text-2xl font-medium">{{ $t('newEvent.event.title') }}</h3>
      <div v-show="swiperButtonShow" class="hidden md:flex items-center justify-center" style="width: fit-content; gap: 8px; margin-right: 60px">
        <div class="flex items-center justify-center" :class="`swiper-button-prev swiper-button-prev-${cid}`" slot="button-prev">
          <i class="owl-direction-left"></i>
        </div>
        <div class="flex items-center justify-center" :class="`swiper-button-next swiper-button-next-${cid}`" slot="button-next">
          <i class="owl-direction-right"></i>
        </div>
      </div>
    </div>
    <div class="relative mx-auto">
      <swiper :options="options" :ref="`new-event-swiper-${cid}`" class="new-event-swiper__wrap justify-center">
        <swiper-slide v-for="(event, index) in list" :key="`swiper-anchor-${index}`">
          <div @click="goToEvent(event)" class="no-underline cursor-pointer" target="_blank">
            <div class="new-event-swiper__col__cover__wrap">
              <div class="new-event-swiper__col__cover" v-lazy:background-image="coverImage(event, index)"></div>
            </div>
            <!-- <div class="desp m-8">
              <h5 class="text-base font-bold text-grey-darker mb-4">{{ event.title }}</h5>
              <p class="text-sm tracking-wide leading-md text-grey-darker">{{ event.subject }}</p>
            </div> -->
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NewEventSwiper',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      cid: this._uid,
      options: {
        loop: false,
        preventInteractionOnTransition: true,
        slideToClickedSlide: false,
        navigation: {
          nextEl: `.swiper-button-next-${this._uid}`,
          prevEl: `.swiper-button-prev-${this._uid}`
        },
        breakpoints: {
          3000: {
            slidesPerView: 3.5,
            slidesPerGroup: 3.5,
            spaceBetween: 24
          },
          800: {
            slidesPerView: 2.3,
            slidesPerGroup: 2,
            spaceBetween: 16
          },
          580: {
            slidesPerView: 1.5,
            slidesPerGroup: 1.5,
            spaceBetween: 16
          },
          430: {
            slidesPerView: 1.2,
            slidesPerGroup: 1.2,
            spaceBetween: 16
          }
        }
      },
      swiperButtonShow: false
    }
  },
  computed: {
    ...mapGetters([
      'initWidth'
    ]),
    magazineImageWidth () {
      if (this.initWidth >= 1200) {
        return 381
      } else if (this.initWidth < 1200 && this.initWidth >= 992) {
        return 311
      } else if (this.initWidth < 992 && this.initWidth >= 801) {
        return 236
      } else if (this.initWidth < 801 && this.initWidth >= 768) {
        return 370
      } else if (this.initWidth < 768 && this.initWidth >= 581) {
        return 282
      } else {
        return 381
      }
    }
  },
  methods: {
    coverImage: function (event, index) {
      if (event.id === 'hotelawards') {
        return require('@/assets/images/travelfair/hotelawards.jpg')
      } else {
        return event.image ? `${event.image}?width=${500}` : require('@/assets/images/default-event.jpg')
      }
    },
    goToEvent (event) {
      window.dataLayer.push({
        event: 'super-taste_events',
        key: event.title
      })
      if (event.id === 'hotelawards') {
        window.open('https://supertastetw.pse.is/83b56u', '_blank')
      } else {
        const route = this.$router.resolve({
          name: 'Event',
          params: { eventId: event.id },
        })
        window.open(route.href, '_blank')
      }
    }
  },
  mounted() {
    // console.log('swiper container width', this.$refs[`section-recommend-hotel-${this.cid}`].swiper.width)
    // console.log('all slides width', this.$refs[`section-recommend-hotel-${this.cid}`].swiper.virtualSize)
    this.$nextTick(() => {
      const swiperWidth = this.$refs[`new-event-swiper-${this.cid}`]?.swiper?.width
      const swiperSlideWidth = this.$refs[`new-event-swiper-${this.cid}`]?.swiper?.virtualSize
      if (swiperSlideWidth > swiperWidth) {
        this.swiperButtonShow = true
      } else {
        this.swiperButtonShow = false
      }
    })
  }
}
</script>
<style lang="sass" scoped>
.new-event-swiper
  @apply select-none
  @apply mb-0 py-16
  box-sizing: border-box
  transform: translateY(0px)
  @screen md
    @apply mb-48 py-0
  &__col
    @apply p-8
    &__cover
      @apply w-full ease
      border-radius: 1.25rem
      padding-top: imageRatio(385, 250)
      background:
        position: center
        repeat: no-repeat
        size: cover
      transform: scale(1.005)
      &:hover
        transform: scale(1.05)
      &__wrap
        @apply overflow-hidden
        border-radius: 1.25rem
  &__wrap
    @apply mx-auto flex items-center overflow-scroll
    // flex: 1
    // max-width: 1200px
    // height: 52px
    -ms-overflow-style: none
    scrollbar-width: none
    padding-inline-start: 0
    align-items: stretch
    @screen lg
      // height: 60px
    &::-webkit-scrollbar
      display: none
</style>
<style lang="sass">
.new-event-swiper
  .swiper-container
    @apply px-16
    @screen sm
      @apply px-0
    .swiper-slide
      max-width: 500px
  .swiper-button-prev, .swiper-button-next
    @apply outline-none #{!important} rounded-full bg-grey-darkest
    position: relative !important
    background-image: none !important
    width: 35px !important
    height: 35px !important
    margin-top: 0px !important
    z-index: 8
    i[class*=owl-direction]
      @apply text-white
      font-size: 18px
  .swiper-button-prev
    left: initial
    // @screen sm
    //   left: -5px !important
  .swiper-button-next
    right: initial
    // @screen sm
    //   right: -5px !important
  .swiper-button-disabled
    @apply cursor-not-allowed bg-grey-darker
</style>
